<template>
    <div class="home_navi">
        <div class="homeNavi"  @mouseenter="showHoverNavi()" @mouseleave="closeHoverNavi()">
              <div class="hoverLogoContent" id="hoverLogoContentId"></div>
              <div class="hoverWhite" id="hoverWhiteId">
                <img src="~@/assets/HomeNavi/logo.png" alt="" class="hoverMainImg"  @click="jumpWithPermission('可游客','','/')">
                <img src="~@/assets/HomeNavi/黑箭头.png" alt="" class="hoverJiantou"  @click="jumpWithPermission('可游客','','/')">
                <div class="hoverLine"></div>
                <div @click="jumpWithPermission('可游客','/store','/rskit')" class="hoverLogo" @mouseenter="showHoverLogo(7)" @mouseleave="closeHoverLogo(7)">
                    <img src="~@/assets/HomeNavi/遥感商城icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 22px;">
                    <div class="hoverLogoText1" id="hoverLogoText1Id7">遥感商城</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id7">吉林一号全品在售</div>
                </div>
                <div @click="jumpWithPermission('仅登录','/lab','/rskit')" class="hoverLogo" style="left: 252px;" @mouseenter="showHoverLogo(5)" @mouseleave="closeHoverLogo(5)">
                    <img src="~@/assets/HomeNavi/实验室icon_蓝.png" alt="" class="hoverImg" style="width: 30px;height: 24px;left: 22px;">
                    <div class="hoverLogoText1" id="hoverLogoText1Id5">实验室</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id5">卫星遥感数据与AI工具</div>
                </div>
                <div @click="jumpWithPermission('可游客', '/openPlatform/home', '/rskit')" class="hoverLogo" style="top: 167px"  @mouseenter="showHoverLogo(10)" @mouseleave="closeHoverLogo(10)">
                  <img src="~@/assets/HomeNavi/能力开放平台icon_蓝.png" alt="" class="hoverImg"/>
                  <div class="hoverLogoText1" style="width: 120px;" id="hoverLogoText1Id10">能力开放平台</div>
                  <div class="hoverLogoText2" id="hoverLogoText2Id10">一站式遥感应用赋能平台</div>
                </div>
                <div @click="jumpWithPermission('可游客','/edu','/rskit')" class="hoverLogo" style="top: 167px;left: 252px;" @mouseenter="showHoverLogo(9)" @mouseleave="closeHoverLogo(9)">
                  <img src="~@/assets/HomeNavi/教育专区icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 18px;">
                  <div class="hoverLogoText1" id="hoverLogoText1Id9">教育专区</div>
                  <div class="hoverLogoText2" id="hoverLogoText2Id9">教育认证会员专享权益</div>
                </div>
                <div @click="jumpWithPermission('可游客','/resrepo','/rskit')" class="hoverLogo" style="top: 234px;" @mouseenter="showHoverLogo(8)" @mouseleave="closeHoverLogo(8)">
                    <img src="~@/assets/HomeNavi/资源库icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 22px;">
                    <div class="hoverLogoText1" id="hoverLogoText1Id8">资源库</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id8">一站式遥感资源中心</div>
                </div>
                <div @click="jumpWithPermission('可游客','/forum','/rskit')"  class="hoverLogo" style="top: 234px;left: 252px;" @mouseenter="showHoverLogo(2)" @mouseleave="closeHoverLogo(2)">
                    <img src="~@/assets/HomeNavi/星林社区icon_蓝.png" alt="" class="hoverImg">
                    <div class="hoverLogoText1" id="hoverLogoText1Id2">星林社区</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id2">遥感应用知识交流分享</div>
                </div>
                <div @click="jumpWithPermission('仅登录','/learn','/rskit')" class="hoverLogo" style="top: 301px;" @mouseenter="showHoverLogo(3)" @mouseleave="closeHoverLogo(3)">
                    <img src="~@/assets/HomeNavi/开放学堂icon_蓝.png" alt="" class="hoverImg" style="width: 24px;height: 18px;">
                    <div class="hoverLogoText1" id="hoverLogoText1Id3">开放学堂</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id3">手把手教你用吉林一号</div>
                </div>
                <div @click="jumpWithPermission('可游客','/contest','/rskit')"  class="hoverLogo" style="top: 301px;left: 252px;" @mouseenter="showHoverLogo(4)" @mouseleave="closeHoverLogo(4)">
                    <img src="~@/assets/HomeNavi/创新大赛icon_蓝.png" alt="" class="hoverImg" style="width: 23px;">
                    <div class="hoverLogoText1" id="hoverLogoText1Id4">创新大赛</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id4">卫星和你创未来</div>
                </div>
                <div @click="jumpWithPermission('可游客', '/jl1release', '/rskit')"  class="hoverLogo" style="top: 368px" @mouseenter="showHoverLogo(1)" @mouseleave="closeHoverLogo(1)">
                    <img src="~@/assets/HomeNavi/一号发布icon_蓝.png" alt="" class="hoverImg">
                    <div class="hoverLogoText1" id="hoverLogoText1Id1">一号发布</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id1">遥感专题资讯及数据集</div>
                </div>
                <div @click="jumpWithPermission('可游客','/popular','/rskit')" class="hoverLogo" style="top: 368px;left: 252px;" @mouseenter="showHoverLogo(6)" @mouseleave="closeHoverLogo(6)">
                    <img src="~@/assets/HomeNavi/科普基地icon_蓝.png" alt="" class="hoverImg">
                    <div class="hoverLogoText1" id="hoverLogoText1Id6">科普基地</div>
                    <div class="hoverLogoText2" id="hoverLogoText2Id6">吉林一号进万家</div>
                </div>
              </div>
        </div>
        <div class="menuLine3"></div>
        <img src="~@/assets/HomeNavi/遥感商城logo.png" alt="" class="logo" @click="jumpWithPermission('可游客','/store','/rskit')">
        <div class="menu">
          <div :class="$route.path=='/' ? 'menuCtn-s' : 'menuCtn'" @click="$router.push('/')">首页</div>
          <div :class="$route.path.includes('GeneralTraffic') ? 'menuCtn-s' : 'menuCtn'" style="margin-left: 36px;width: 120px;" @click="$router.push('/GeneralTraffic/Home')">通用流量</div>
          <div :class="$route.path.includes('AnnualPurchase') ? 'menuCtn-s' : 'menuCtn'" style="margin-left: 36px;width: 120px;" @click="$router.push('/AnnualPurchase/Home')">图源包年</div>
          <div :class="$route.path=='/rsManage' ? 'menuCtn-s' : 'menuCtn'" style="margin-left: 36px;width: 120px;" @click="$router.push('/rsManage')">图源管理</div>
        </div>
        <div class="homeText" @click="jumpWithPermission('可游客','/store','/rskit')">返回商城主页</div>
        <div class="menuLine1"></div>
        <div class="contract" @click="connectStatus=true">联系我们</div>
        <div class="login" @click="$router.push('/Login')" v-if="!$store.state.user.logined">登录</div>
        <div class="login-s" @mouseenter="showLoginPanel = true" @mouseleave="showLoginPanel = false" v-if="$store.state.user.logined">
          <img src="../assets/HomeNavi/默认头像.png" alt="" class="loginIcon" v-if="avatar == '' || avatar == undefined || avatar == null">
          <img v-if="avatar" :src="avatar" class="loginIcon"/>
          <div v-show="showLoginPanel" class="loginOperateCtn">
            <div style="position: absolute;top: -30px;right: 0px;width: 100px;height: 50px;"></div>
            <div class="topTriangle"></div>
            <!--工作台跳转-->
            <div v-if="authenticationStatus=='0'" class="login_line" style="margin-top: 34px; height: 130px;width: 342px;margin-left: 29px;">
                <div  @click="jumpUrl(3)" class="login_panel_ctn">
                    <div style="height: 96px">
                        <img src="../assets/HomeNavi/我的订单.png" height="96" width="96" />
                    </div>
                    <div class="login_panel_txt">我的订单</div>
                </div>
                <div @click="$router.push('/agentHome');$store.state.user.agentStatusSelect=2;" class="login_panel_ctn" v-if="agentStatus=='已通过' || agentStatus=='已过期'">
                    <div style="height: 96px">
                        <img src="../assets/HomeNavi/我的代理_蓝.png" height="96" width="96"/>
                    </div>
                    <div class="login_panel_txt">我的代理</div>
                </div>
                <div @click="jumpUrl(2)" class="login_panel_ctn">
                    <div style="height: 96px">
                        <img src="../assets/HomeNavi/个人中心.png" height="96" width="96"/>
                    </div>
                    <div class="login_panel_txt">个人中心</div>
                </div>
            </div>
            <!--工作台跳转-->
            <div v-if="authenticationStatus=='1'" class="login_line" style="margin-top: 34px; height: 100px">
                <div  class="login_vipType_ctn">
                    <div class="lvc_txt1" style="text-align: left;">实名可进入工作台</div>
                    <div class="lvc_txt2">订单 应用 个人中心</div>
                    <div @click="$router.push('/Authentication')" class="lvc_txt3" style="background: #0080ff">立即实名</div>
                </div>
            </div>
            <!--分割线-->
            <div style=" width: 100%; height: 1px; border: 1px solid rgba(0, 0, 0, 0.09); margin-top: 32px;"></div>
            <div class="login_line" style="position: relative; height: 74px">
                <div @click="jumpUrl(1)" class="login_line_button" style="left: 36px">商城指南</div>
                <div v-if="authenticationStatus=='1'" @click="accountInfoDialog=true" class="login_line_button" style="left: 172px">账号信息</div>
                <div @click="logout()" class="login_line_button" style="left: 306px">退出登录</div>
            </div>
          </div>
        </div>
        <div class="shadow" v-if="connectStatus">
            <div class="dialog2" >
                <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="connectStatus=false"/>
                <img src="https://market.obs.cn-north-4.myhuaweicloud.com/jl1mall/lianxiren.png" alt="" class="dialogImg4" />
                <div class="guanwang" @click="goGuanwang()"></div>
            </div>
        </div>
        <!-- 领取每日免费流量弹窗 -->
        <div class="shadow" v-if="showFreePackageDialog">
            <div class="free-dialog">
                <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="showFreePackageDialog=false"/>
                <div class="free-dialog-title">领取每日免费流量</div>
                <div class="free-dialog-desc">每日免费流量可用于"基础图源-免费体验图源"</div>
                <div class="free-dialog-check">
                    <input type="checkbox" v-model="agreedTerms" class="free-checkbox"/>
                    <span class="free-check-text">我已阅读并同意</span>
                    <span class="free-link" @click="openPDF()">《吉林一号在线访问产品使用协议》</span>
                </div>
                <div class="free-dialog-buttons">
                    <div class="free-btn-cancel" @click="showFreePackageDialog=false">暂不领取</div>
                    <div class="free-btn-confirm" :class="{'free-btn-disabled': !agreedTerms}" @click="handleClaim">立即领取</div>
                </div>
            </div>
        </div>
        <!-- 领取成功弹窗 -->
        <div class="shadow" v-if="showSuccessDialog">
            <div class="success-dialog">
                <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="showSuccessDialog=false"/>
                <div class="success-icon">
                    <span class="success-check">✓</span>
                </div>
                <div class="success-title">领取成功！</div>
                <div class="success-desc">
                    每日免费流量每日发放<span class="success-highlight">4W次</span>，次日重置<br/>
                    可前往"在线地图访问-图源管理"查看每日免费流量的使用情况以及使用<span class="success-link-text">【基础图源-免费体验图源】</span>
                </div>
                <div class="success-buttons">
                    <div class="success-btn-cancel" @click="showSuccessDialog=false">暂不前往</div>
                    <div class="success-btn-confirm" @click="goToRsManage">立即前往</div>
                </div>
            </div>
        </div>
        <double11-success-dialog :visible="showD11SuccessDialog" @close="showD11SuccessDialog=false"></double11-success-dialog>
    </div>


</template>

<script>
// import {rootUrl} from '@/globalConfig'
import Double11SuccessDialog from './double11/Double11SuccessDialog.vue'
import {rootUrl, CHANNEL_PARAMS} from '@/globalConfig'
export default {
    name: "newHomeNavi",
    components: { Double11SuccessDialog },
    inject: ["reload"],
    data() {
        return {
            showLoginPanel: false,
            avatar:"",
            connectStatus:false,
            authenticationStatus:1,
            agentStatus:'',
            showFreePackageDialog: false,
            showSuccessDialog: false,
            agreedTerms: false,
            showD11SuccessDialog: false,
        }
    },
    mounted(){
        this.channelReport()
        //如果从商城端跳入，同步token状态
        let token=this.$route.query.tk;
        if(token){
        this.setLocalStorageItem('token',token);
        }
        this.getLoginInfo();
        //定时判断用户登录状态，每分钟一次，如果是登录超时则返回登录页
        this.$nextTick(() => {
        setInterval(this.getIfTimeout, 600000);
        });
        this.getUserData()
    },
    watch: {
        '$route'(to) {
            if ((to.path === '/' || to.path === '/rsManage') && this.$store.state.user.logined) {
                this.checkTodayFreePackage();
            }
            if (this.$store.state.user.logined) {
                this.checkD11DelayedGrant();
            }
        },
        '$store.state.user.logined': {
            handler: function (val) {
                if (val) {
                    this.checkD11DelayedGrant();
                }
            },
            immediate: true
        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        // double11 delayed grant: single call per app load (no polling)
        checkD11DelayedGrant() {
            this.axios.post('/tileflowapi/flow/package/double11/delayedGrant', null, {
                headers: { Authorization: 'Bearer ' + this.getKey() },
            }).then((res) => {
                // data===true 只会在补发发放成功那一刻返回一次：无条件弹窗（写 key 仅用于抑制首页自动检查的重复弹）
                if (res.data.code === 200 && res.data.data === true) {
                    sessionStorage.setItem('double11SuccessAutoShown', '1');
                    this.showD11SuccessDialog = true;
                }
            }).catch((e) => { console.log(e); });
        },
        channelReport() {
            const company = localStorage.getItem("agentCompany");
            if (!company || !Object.prototype.hasOwnProperty.call(CHANNEL_PARAMS, company)) return;
            const agent = localStorage.getItem("agent") || "";
            const headers = {};
            if (this.getKey()) {
                headers.Authorization = "Bearer " + this.getKey();
            }
            this.axios.post("/loginapi/drain/add", {
                url: window.location.origin + "/rskit/?agentCompany=" + company + "&agent=" + agent,
                agent: agent,
                agentCompany: company,
            }, { headers: headers });
        },
        //带权限判断的跳转
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        jumpUrl(i){
            if(i==1){
                this.jumpWithPermission('可游客','/store/MallGuide','/rskit')
            }else if(i==2){
              this.jumpWithPermission('可游客','/store/UserCenter?initial_status=close','/rskit')  
            }else if(i==3){
                this.jumpWithPermission('可游客','/store/MyOrderManage','/rskit')
            }
        },
        getLoginInfo() {
          let that = this;
          this.axios
              .get("/loginapi/getLoginInfo", {
                headers: {
                  'Cache-Control': 'no-cache',
                  Authorization: "Bearer " + this.getKey(),
                },
              })
              .then((res) => {
                if (res.data.success) {
                  if(res.data.data.phone==19390074527){
                    window.open(rootUrl,"_self")
                  }
                  this.$store.state.user.userId = res.data.data.account;
                  this.$store.state.user.name = res.data.data.name;
                  this.$store.state.user.vipLevel = res.data.data.vipLevel;
                  this.setCookie("userId", res.data.data.account);
                  this.setCookie(
                      "userInfo",
                      JSON.stringify({
                        phone: res.data.data.phone,
                        location: res.data.data.location,
                      })
                  );
                  this.$store.state.user.logined = true;
                  let authentication = res.data.data.authentication
                  this.$store.state.user.authentication =authentication; //是否实名认证，0是，1否
                  this.setLocalStorageItem("authentication",authentication); //是否实名认证，0是，1否;为方便其他系统用
                  this.setLocalStorageItem('token',res.data.data.key); //getuserInfo也需要赋值token，为把三部token替换为本部门token
                  localStorage.setItem("chatUserId", res.data.data.userId);//用户在线客服的userId
                  this.authenticationStatus=authentication
                  this.vipLevel = res.data.data.vipLevel;
                  this.vipType = res.data.data.vipType;
                  this.vipActivityStatus = res.data.data.vipActivityStatus;
                  this.avatar = res.data.data.avatar;
                  if (res.data.data.endTime) {
                    this.vip_endTime = res.data.data.endTime.split(" ")[0];
                  }
                  // 在首页和图源管理页面检查每日免费流量
                  if (this.$route.path === '/' || this.$route.path === '/rsManage') {
                    this.checkTodayFreePackage();
                  }
                } else {
                  this.$store.state.user.logined = false;
                  this.$store.state.user.authentication=1
                  // 未登录必须跳转至登录页
                  this.$store.state.user.userId = "";
                  localStorage.setItem("userId", "");
                  localStorage.setItem("authentication", "1");
                  this.$router.push("/Login");
                }
              });
        },
        setLocalStorageItem(key, value) {
            localStorage.setItem(key, value);
        },
        getIfTimeout(){
            let that=this;
            that.axios
                .get("/loginapi/getLoginInfo", {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                })
                .then((res) => {
                    this.print(res)
                    if (res.data.success) {
                    this.$store.state.user.userId = res.data.data.account;
                    this.$store.state.user.name = res.data.data.name;
                    this.$store.state.user.vipLevel = res.data.data.vipLevel;
                    this.setCookie("userId", res.data.data.account);
                    this.setCookie(
                        "userInfo",
                        JSON.stringify({
                            phone: res.data.data.phone,
                            location: res.data.data.location,
                        })
                    );
                    this.$store.state.user.logined = true;
                    this.avatar = res.data.data.avatar;
                    } else {
                    this.$store.state.user.logined = false;
                        if (that.getCookie("userId")) {
                            setTimeout(() => {
                            this.$store.state.user.userId = "";
                            localStorage.setItem("userId", "");
                            this.$router.push("/Login");
                            }, 2000);
                        }
                    }
                });
        },
        logout(){
          this.setLocalStorageItem('userId', '');
          this.$store.state.user.logined = false;
          this.$store.state.user.agentStatusSelect = 0;
          this.$store.state.user.agentStatus = '';
          this.agentStatus='';
          this.axios.get('/loginapi/logout', {headers: { Authorization: 'Bearer ' + this.getKey() },});
          this.setLocalStorageItem('token', '');
          this.setLocalStorageItem('chatUserId','');
          this.$router.push('/');
          this.setLocalStorageItem('userPhone', '');
          location.reload();
        },
        showHoverNavi(){
            let hoverLogoContentId = document.getElementById("hoverLogoContentId");
            hoverLogoContentId.style.width = "44px";
            hoverLogoContentId.style.height = "100px";
            let hoverWhite = document.getElementById("hoverWhiteId");
            hoverWhite.style.width = "500px";
            hoverWhite.style.height = "450px";
        },
        closeHoverNavi(){
            let hoverLogoContentId = document.getElementById("hoverLogoContentId");
            hoverLogoContentId.style.width = "0px";
            hoverLogoContentId.style.height = "0px";
            let hoverWhite = document.getElementById("hoverWhiteId");
            hoverWhite.style.width = "0px";
            hoverWhite.style.height = "0px";
        },
        showHoverLogo(i){
            let hoverLogoText1Id = document.getElementById("hoverLogoText1Id"+i);
            hoverLogoText1Id.style.top = "6px";
            let hoverLogoText2Id = document.getElementById("hoverLogoText2Id"+i);
            hoverLogoText2Id.style.opacity = 1;
        },
        closeHoverLogo(i){
            let hoverLogoText1Id = document.getElementById("hoverLogoText1Id"+i);
            hoverLogoText1Id.style.top = "17px";
            let hoverLogoText2Id = document.getElementById("hoverLogoText2Id"+i);
            hoverLogoText2Id.style.opacity = 0;
        },
        goGuanwang(){
        window.open("http://www.jl1.cn/")
        },
        //用户信息回显
        getUserData(){
          this.axios.post("/tilesapi/queryUserInfo",null, {
              headers: {
              Authorization: "Bearer " + this.getKey(),
              },
          }).then((res)=>{
              let data = res.data.data
              this.$store.state.county.name = data.name;
              this.$store.state.county.company = data.company;
              this.$store.state.county.age = data.age;
              this.$store.state.county.sex = data.sex;
              this.$store.state.county.education = data.education;
          })
        },
        // 检查今日是否已领取免费流量包
        checkTodayFreePackage(){
          // 弹窗已在显示或正在领取流程中，不重复触发
          if (this.showFreePackageDialog || this.showSuccessDialog) return;
          this.axios.get('/tileflowapi/flow/package/checkTodayFreePackage', {
            headers: {
              Authorization: 'Bearer ' + this.getKey(),
            },
          }).then((res) => {
            if (res.data.code === 200) {
              if (res.data.data === false) {
                // 检查是否有从实名认证页面返回的待领取标记
                let pendingClaim = localStorage.getItem('pendingFreeClaim');
                if (pendingClaim === 'true') {
                  localStorage.removeItem('pendingFreeClaim');
                  // 实名认证通过后自动领取
                  this.doClaimFreePackage();
                } else {
                  this.showFreePackageDialog = true;
                }
              } else {
                // 已领取过，清除待领取标记
                localStorage.removeItem('pendingFreeClaim');
              }
            }
          });
        },
        // 点击"立即领取"按钮
        handleClaim(){
          if (!this.agreedTerms) return;
          // 实名校验
          let authentication = localStorage.getItem('authentication');
          if (authentication !== '0') {
            // 未实名，设置待领取标记后跳转实名认证页面
            localStorage.setItem('pendingFreeClaim', 'true');
            window.open(rootUrl + '/Authentication', '_self');
            return;
          }
          this.doClaimFreePackage();
        },
        // 调用领取接口
        doClaimFreePackage(){
          this.axios.post('/tileflowapi/flow/package/claimFreePackage', null, {
            headers: {
              Authorization: 'Bearer ' + this.getKey(),
            },
          }).then((res) => {
            if (res.data.code === 200) {
              this.showFreePackageDialog = false;
              this.showSuccessDialog = true;
            }
          });
        },
        // 跳转至图源管理页面并下滑至图源列表
        goToRsManage(){
          this.showSuccessDialog = false;
          this.$router.push({
            path: '/rsManage',
            hash: '#source-list-section',
          }).catch(() => {});
        },
        openPDF(){
            window.open("https://files.jl1mall.com/jl1store/document/吉林一号在线访问产品使用协议.pdf")
        },
    }
}
</script>

<style scoped>
.messageTip{
  position:absolute;
  width: 6px;
  height: 6px;
  background: #FF4040;
  border-radius: 3px;
}
.home_navi {
  background: #ffffff;
  width: 100%;
  height: 76px;
  position: fixed;
  z-index: 1000;
  top: 0px;
  border-bottom: 1px solid #F7F7F7;

}
.homeNavi{
    position: absolute;
top: 15px;
left: 20px;
  width: 44px;
  height: 44px;
  /* margin-top: 16px; */
  /* margin-left: 10rem; */
  background-image: url('~@/assets/HomeNavi/导航按钮.png');
  cursor: pointer;
  display: block;
}
.homeNavi:hover {
    background-image: url("~@/assets/HomeNavi/导航按钮hover.png");
    /* background-color: pink; */
  }
  .menuLine3{
    position: absolute;
    top: 18px;
    left: 84px;
    width: 1px;
    height:40px;
    background-color:  #CCCCCC;
    opacity: 0.8;
}
.hoverLogoContent{
  position: fixed;
  top: 60px;
  left: 20px;
  width: 0px;
  height: 0px;
  overflow: hidden;
}
.hoverWhite{
  position: fixed;
  top: 76px;
  left: 20px;
  width: 0px;
  height: 0px;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 2px rgba(0,0,0,0.2);
  border-radius: 16px;
  transition: 0.3s;
  overflow: hidden;
}
.hoverMainImg{
    position: absolute;
    top: 20px;
    left: 44px;
    width: 175px;
    height: 40px;
  }
  .hoverJiantou{
    position: absolute;
    width: 18px;
    height: 16px;
    top: 35px;
    left: 433px;
  }
  .hoverLine{
    position: absolute;
    top: 80px;
    left: 28px;
    width: 444px;
    height: 1px;
    border-top: 1px solid #CCCCCC;
  }
  .hoverLogo{
    position: absolute;
    top: 100px;
    left: 28px;
    width: 220px;
    height: 60px;
    background: #fff;
    border-radius: 6px;
    }
  .hoverLogo:hover{
  background: #F7F7F7;
  }
  .hoverImg{
    position: absolute;
    top: 19px;
    left: 24px;
    width: 20px;
    height: 20px;
  }
  .hoverLogoText1{
    position: absolute;
    top: 17px;
    left: 66px;
    width: 85px;
    height: 24px;
    font-size: 20px;
    font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
    font-weight: normal;
    color: #3A3A3A;
    line-height: 24px;
  }
  .hoverLogoText2{
    position: absolute;
    top: 35px;
    left: 66px;
    width: 133px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #979797;
    line-height: 17px;
    opacity: 0;
  }
.logo{
    position: absolute;
    top: 18px;
    left: 118px;
    width: 156px;
    height: 49px;
    cursor: pointer;
}

.login{
    position: absolute;
    top: 11px;
    right: 30px;
    width: 54px;
    height: 54px;
    background: #EAEAEA;
    border-radius: 50%;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 54px;
    text-align: center;
    cursor: pointer;
}
.login-s{
    position: absolute;
    top: 11px;
    right: 30px;
    width: 54px;
    height: 66px;
    cursor: pointer;
}
.loginIcon{
    position: absolute;
    top: 0;
    left: 0;
    width: 54px;
    height: 54px;
}
.loginOperateCtn{
    position: absolute;
    top: 76px;
    left: -340px;
    width: 400px;
    min-height: 270px;
    height: auto;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
    cursor: default;
}
.topTriangle {
        position: absolute;
        top: -10px;
        right: 20px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 12px solid #ffffff;
}
.login_line {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width:100%;
    height: auto;
}
.login_panel_ctn {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 97px;
    height: 130px;
    float: left;
    cursor: pointer;
    }
    .login_panel_txt {
    margin-top: 10px;
    width: 100%;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5a5a5a;
    line-height: 22px;
    text-align: center;
    }
    .login_line_button {
    position: absolute;
    top: 20px;
    width: 80px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3a3a3a;
    line-height: 30px;
    cursor: pointer;
    }
    .login_vipType_ctn {
        position: relative;
        width: 342px;
        height: 96px;
        background: linear-gradient(90deg, #f5f5f5 0%, #dcdcdc 100%);
        border-radius: 8px;
    }
        .lvc_txt1 {
        position: absolute;
        width: 159px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5a5a5a;
        line-height: 20px;
        top: 27px;
        left: 19px;
    }
    .lvc_txt2 {
    position: absolute;
    top: 51px;
    left: 19px;
    width: 109px;
    height: 18px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 18px;
    }
        .lvc_txt3 {
    position: absolute;
    top: 30px;
    left: 213px;
    width: 108px;
    height: 36px;
    background: #3a3a3a;
    border-radius: 18px;
    line-height: 36px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    }
.loginName{
    width: 200px;
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight:400;
    color: #CCCCCC;
    line-height: 50px;
    text-align: center;
}
.loginLine{

    width: 120px;
  margin-left: auto;
  margin-right: auto;
height: 1px;
background: #D8D8D8;

}
.loginText{

    width: 200px;
height: 50px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 50px;
text-align: center;
cursor: pointer;
}
.shadow{
  position: fixed;
  top: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}
.dialog2 {
    position: absolute;
  width: 600px;
  height: 400px;
  border-radius: 16px;
  left: calc(50% - 300px);
  top: calc(50% - 200px);
  z-index: 10001;
  background: #ffffff;
}
.dialogImg1{
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.dialogImg4 {
position: absolute;
width: 505px;
height: 306px;
top: calc(50% - 153px);
left: calc(50% - 252px);
}
.guanwang{
  position: absolute;
  /* background-color: pink; */
  width: 100px;
  height: 20px;
  top: 277px;
  left: 440px;
  cursor: pointer;
}
.menu{
  position: absolute;
  width: 560px;
  top: 20px;
  height: 36px;
  left: 50%;
  transform: translate(-50%,0);
}
.menuCtn{
  float: left;
  width: 92px;
  height: 36px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;
  line-height:36px;
  text-align: center;
  cursor: pointer;
}
.menuCtn-s{
  float: left;
  width: 92px;
  height: 36px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;
  line-height:36px;
  text-align: center;
  cursor: pointer;
  background: #F5F5F6;
  border-radius: 10px;
}
.contract{
  position: absolute;
  width: 128px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #3A3A3A;
  top: 18px;
  right: 124px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.menuLine1{
  position: absolute;
  top: 18px;
  right: 301px;
  width: 1px;
  height: 40px;
  border-left: 1px solid rgba(204,204,204,0.5);
}
.homeText{
  position: absolute;
  top: 28px;
  right: 352px;
  width: auto;
  height: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3A3A3A;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
}
/* 领取每日免费流量弹窗 */
.free-dialog {
  position: absolute;
  width: 480px;
  height: auto;
  padding: 40px 48px 36px;
  border-radius: 16px;
  left: calc(50% - 288px);
  top: calc(50% - 160px);
  z-index: 10001;
  background: #ffffff;
  box-sizing: border-box;
}
.free-dialog-title {
  width: 100%;
  height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 24px;
  color: #1F1F1F;
  line-height: 32px;
  text-align: center;
}
.free-dialog-desc {
  width: 100%;
  height: 24px;
  margin-top: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: center;
}
.free-dialog-check {
  width: 100%;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.free-checkbox {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  cursor: pointer;
  accent-color: #1890FF;
}
.free-check-text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}
.free-link {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1890FF;
  line-height: 20px;
  cursor: pointer;
}
.free-dialog-buttons {
  width: 100%;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.free-btn-cancel {
  width: 160px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  background: #ffffff;
}
.free-btn-cancel:hover {
  border-color: #40A9FF;
  color: #40A9FF;
}
.free-btn-confirm {
  width: 160px;
  height: 44px;
  border-radius: 8px;
  background: #1890FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.free-btn-confirm:hover {
  background: #40A9FF;
}
.free-btn-disabled {
  background: #BAE0FF;
  cursor: not-allowed;
}
.free-btn-disabled:hover {
  background: #BAE0FF;
}
/* 领取成功弹窗 */
.success-dialog {
  position: absolute;
  width: 480px;
  height: auto;
  padding: 40px 48px 36px;
  border-radius: 16px;
  left: calc(50% - 288px);
  top: calc(50% - 160px);
  z-index: 10001;
  background: #ffffff;
  box-sizing: border-box;
}
.success-icon {
  width: 48px;
  height: 48px;
  background: #52C41A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}
.success-check {
  color: #ffffff;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}
.success-title {
  width: 100%;
  height: 28px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  text-align: center;
}
.success-desc {
  width: 100%;
  margin-top: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 24px;
  text-align: center;
}
.success-highlight {
  font-weight: 600;
  color: #FF6600;
}
.success-link-text {
  color: #1890FF;
}
.success-buttons {
  width: 100%;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.success-btn-cancel {
  width: 160px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  background: #ffffff;
}
.success-btn-cancel:hover {
  border-color: #40A9FF;
  color: #40A9FF;
}
.success-btn-confirm {
  width: 160px;
  height: 44px;
  border-radius: 8px;
  background: #1890FF;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.success-btn-confirm:hover {
  background: #40A9FF;
}

</style>
